<template>
    <BreadcrumbsProject
        v-if="$route.meta.layout !== 'deluxe'"
        :breadcrumbs="[
            {
                link : dotNetUrl+'/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : '/Project/' + projectInfo._id,
                title : (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: true
            },
            {
                link : '/Project/' + projectInfo._id + '/directory' ,
                title : $t('Directory'),
                isRouterLink: true
            }
        ]"
    ></BreadcrumbsProject>
    <div>
        <StepItem2 :deluxe="$route.meta.layout === 'deluxe'"></StepItem2>
    </div>
    <div >
        <Loader v-if="loaderProject"></Loader>  
        <DirectoryInfo :openPermission="OpenPermissionModal" v-else></DirectoryInfo>
    </div>
    <Modal idModal="PermissionModal" :headerTitle="$t('Change User Permission')" modalSize="modal-xl">
        <div class="directory-permission-modal">
            <div class="directory-permission-summary">
                <div>
                    <span class="directory-permission-summary__eyebrow">{{ $t('Project Access') }}</span>
                    <strong>{{ $t('Change User Permission') }}</strong>
                </div>
                <span class="directory-permission-summary__count">
                    <strong>{{ selectedPermission.length }}</strong>
                    <span>{{ $t('Selected') }}</span>
                </span>
            </div>
            <div class="directory-permission-grid">
                <section
                class="directory-permission-card"
                :class="{ 'directory-permission-card--active': IsGroupSelected(group) || IsGroupPartiallySelected(group) }"
                v-for="(group,key) in ModuleActionGroupings"
                :key="key"
                >
                    <button
                    type="button"
                    class="directory-permission-card__header"
                    @click="TogglePermissionGroup(group)"
                    >
                        <span
                        class="directory-permission-check"
                        :class="{
                            'directory-permission-check--checked': IsGroupSelected(group),
                            'directory-permission-check--partial': IsGroupPartiallySelected(group)
                        }"
                        >
                            <i v-if="IsGroupSelected(group)" class="fa-solid fa-check"></i>
                            <i v-else-if="IsGroupPartiallySelected(group)" class="fa-solid fa-minus"></i>
                        </span>
                        <span class="directory-permission-card__title">
                            <span
                            v-if="PermissionGroupSvg(group.module)"
                            class="directory-permission-card__svg"
                            v-html="PermissionGroupSvg(group.module)"
                            ></span>
                            <i v-else :class="PermissionGroupIcon(group.module)"></i>
                            {{ PermissionGroupLabel(group.module) }}
                        </span>
                        <span class="directory-permission-card__count">{{ PermissionGroupCount(group) }}/{{ group.actions.length }}</span>
                    </button>
                    <div class="directory-permission-card__body">
                        <label
                        class="directory-permission-action"
                        :class="{ 'directory-permission-action--active': IsPermissionSelected(action.id) }"
                        :for="'permission-action-' + action.id"
                        v-for="(action,actionKey) in group.actions"
                        :key="actionKey"
                        >
                            <span class="directory-permission-action__copy">
                                <span class="directory-permission-action__icon">
                                    <i class="fa-solid fa-shield-halved"></i>
                                </span>
                                <span>{{ $t(action.name) }}</span>
                            </span>
                            <input
                            class="directory-permission-action__input"
                            type="checkbox"
                            :id="'permission-action-' + action.id"
                            :checked="IsPermissionSelected(action.id)"
                            @change="TogglePermissionAction(action.id)"
                            />
                        </label>
                    </div>
                </section>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closePermissionModal" class="btn btn-outline-danger" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button type="button" class="btn btn-primary" @click="UpdateUserAccess"  ><i class="fa-solid fa-save"></i>  {{ $t('Save Changes') }}</button>
      </template>
    </Modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Modal from '@/components/layout/Modal.vue'
import BreadcrumbsProject from '../components/projectInformation/BreadcrumbsProject.vue'
import DirectoryInfo from '../components/projectInformation/DirectoryInfo.vue'
import Loader from '../components/layout/Loader.vue'
import StepItem2 from '../components/layout/StepItem2.vue'
import { LinkList,ModuleActionGroupings } from '../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import {UpdateUserProjectAccess} from '../actions/projectActions.js'
import { RedirectToLogin } from '@/helpers/authRedirectHelpers.js'
import 'dotenv/config'
import  i18n from '../translations/i18n.js'
const i18nTranslate = i18n.global.t

export default {
    name : 'ProjectDetails',
    components : {
        Loader,
        StepItem2,
        BreadcrumbsProject,
        DirectoryInfo,
        Modal
    },
    data(){
        return{
            loaderProject: true,
            viewMode : true,
            dotNetUrl: process.env.VUE_APP_DOTNET_URL,
            ModuleActionGroupings : ModuleActionGroupings,
            selectedUser : '',
            selectedPermission : []
        }
    },
    methods :{
        ...mapActions(['GetProjectInfo','GetProjectDirectory','ChangeActiveLink']),
        OpenPermissionModal(data){
            this.selectedUser = data._id
            this.selectedPermission = []
            if(data.accessList)
                if(data.accessList.length!=0)
                    this.selectedPermission.push(...data.accessList)
        },
        TogglePermissionGroup(group){
            const values = group.values || []
            const isSelected = this.IsGroupSelected(group)
            this.selectedPermission = this.selectedPermission.filter(u=>values.indexOf(u)==-1)
            if(!isSelected){
                values.forEach((item)=>{
                    if(this.selectedPermission.indexOf(item)==-1){
                        this.selectedPermission.push(item)
                    }
                })
            }
        },
        TogglePermissionAction(value){
            const getIndex = this.selectedPermission.indexOf(value)
            if(getIndex==-1){
                this.selectedPermission.push(value)
            }else{
                this.selectedPermission.splice(getIndex,1)
            }
        },
        IsPermissionSelected(value){
            return this.selectedPermission.indexOf(value)>-1
        },
        IsGroupSelected(group){
            const values = group.values || []
            return values.length>0 && values.every((item)=>this.IsPermissionSelected(item))
        },
        IsGroupPartiallySelected(group){
            const values = group.values || []
            return values.some((item)=>this.IsPermissionSelected(item)) && !this.IsGroupSelected(group)
        },
        PermissionGroupCount(group){
            return (group.actions || []).filter((action)=>this.IsPermissionSelected(action.id)).length
        },
        PermissionGroupLabel(module){
            return this.$t(module)
        },
        PermissionGroupSvg(module){
            const icons = {
                'Project Details': sidebarSvg.projectDetails,
                'Project Directory': sidebarSvg.directory,
                'Process List': sidebarSvg.process,
                'Item Master List': sidebarSvg.procurement,
                'Bill of Quantities': sidebarSvg.boq,
                'Consolidated List': sidebarSvg.clientInvoice,
                'Quotations': sidebarSvg.quotation,
                'Rate List': sidebarSvg.vendorList,
                'Procurement': sidebarSvg.procurement
            }
            return icons[module] || ''
        },
        PermissionGroupIcon(module){
            const icons = {
                'Project Details': 'fa-solid fa-circle-info',
                'Project Directory': 'fa-solid fa-address-book',
                'Process List': 'fa-solid fa-list-check',
                'Item Master List': 'fa-regular fa-bookmark',
                'Bill of Quantities': 'fa-regular fa-newspaper',
                'Consolidated List': 'fa-solid fa-layer-group',
                'Quotations': 'fa-regular fa-file-lines',
                'Rate List': 'fa-solid fa-coins',
                'Procurement': 'fa-regular fa-bookmark'
            }
            return icons[module] || 'fa-solid fa-shield-halved'
        },
        UpdateUserAccess(e){
            const self = this
            const btn = e.currentTarget
            btn.disabled =true
            UpdateUserProjectAccess(self.selectedUser,self.selectedPermission).then((res)=>{
                btn.disabled =false
                if(res!='OK'){
                    self.$swal(i18nTranslate('Change User permission'), res, 'warning')
                }else{
                    self.GetProjectDirectory(1).then()
                    self.$refs.closePermissionModal.click()
                }
            })
        }
    },
    computed : {
        ...mapGetters(['projectInfo'])
    },
    mounted :async function () {
        const self = this
        self.ChangeActiveLink(LinkList.PROJECT_DIRECTORY)
        const projectId = self.$route.params.id
        self.loaderProject = true
        await self.GetProjectInfo(projectId).catch()
        const directory = await self.GetProjectDirectory().catch()
        if(directory==401){
            RedirectToLogin(self.$route.fullPath)
            return
        }
        self.loaderProject = false
        
    }
}
</script>

<style scoped>
.directory-permission-modal {
    --permission-accent: #298969;
    --permission-accent-dark: #0f6f53;
    --permission-accent-soft: #e8f6ef;
    --permission-border: #d7e0da;
    --permission-text: #252821;
    --permission-muted: #66736d;
}

.directory-permission-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    border: 1px solid var(--permission-border);
    border-radius: 6px;
    padding: 1rem 1.15rem;
    background: #ffffff;
    box-shadow: 0 0.65rem 1.6rem rgba(30, 27, 22, 0.06);
}

.directory-permission-summary > div {
    display: grid;
    gap: 0.2rem;
}

.directory-permission-summary__eyebrow {
    color: var(--permission-muted);
    font-size: 0.74rem;
    font-weight: 800;
}

.directory-permission-summary strong {
    color: var(--permission-text);
    font-size: 1.1rem;
    line-height: 1.2;
}

.directory-permission-summary__count {
    display: inline-flex;
    min-height: 2rem;
    align-items: center;
    gap: 0.35rem;
    border: 1px solid #cfe4da;
    border-radius: 999px;
    padding: 0.35rem 0.75rem;
    color: var(--permission-accent-dark);
    background: var(--permission-accent-soft);
    font-size: 0.78rem;
    font-weight: 800;
    white-space: nowrap;
}

.directory-permission-summary__count strong {
    color: inherit;
    font-size: inherit;
}

.directory-permission-grid {
    display: grid;
    max-height: min(58vh, 38rem);
    grid-template-columns: repeat(auto-fit, minmax(19rem, 1fr));
    gap: 0.85rem;
    overflow: auto;
    padding-right: 0.25rem;
}

.directory-permission-card {
    border: 1px solid var(--permission-border);
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 0.7rem 1.6rem rgba(30, 27, 22, 0.07);
    overflow: hidden;
}

.directory-permission-card--active {
    border-color: #a8d4c2;
}

.directory-permission-card__header {
    display: flex;
    width: 100%;
    min-height: 3.2rem;
    align-items: center;
    gap: 0.65rem;
    border: 0;
    border-bottom: 1px solid var(--permission-border);
    padding: 0.8rem 0.9rem;
    color: var(--permission-text);
    background: #f7fbf9;
    font-weight: 800;
    text-align: left;
}

.directory-permission-card__header:hover {
    background: var(--permission-accent-soft);
}

.directory-permission-check {
    display: inline-flex;
    width: 1.1rem;
    height: 1.1rem;
    flex: 0 0 1.1rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #b9c6bf;
    border-radius: 3px;
    color: #ffffff;
    background: #ffffff;
    font-size: 0.68rem;
}

.directory-permission-check--checked,
.directory-permission-check--partial {
    border-color: var(--permission-accent);
    background: var(--permission-accent);
}

.directory-permission-card__title {
    display: inline-flex;
    min-width: 0;
    flex: 1;
    align-items: center;
    gap: 0.55rem;
}

.directory-permission-card__title i {
    color: var(--permission-accent);
    font-size: 0.92rem;
}

.directory-permission-card__svg {
    display: inline-flex;
    width: 1.1rem;
    height: 1.1rem;
    flex: 0 0 1.1rem;
    align-items: center;
    justify-content: center;
    color: var(--permission-accent);
}

.directory-permission-card__svg :deep(svg) {
    width: 1.1rem;
    height: 1.1rem;
}

.directory-permission-card__svg :deep(path) {
    stroke: currentColor;
}

.directory-permission-card__count {
    display: inline-flex;
    min-height: 1.55rem;
    align-items: center;
    border-radius: 999px;
    padding: 0.2rem 0.55rem;
    color: var(--permission-accent-dark);
    background: #ffffff;
    font-size: 0.74rem;
    font-weight: 800;
    white-space: nowrap;
}

.directory-permission-card__body {
    display: grid;
}

.directory-permission-action {
    display: flex;
    min-height: 2.8rem;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    margin: 0;
    border-bottom: 1px solid var(--permission-border);
    padding: 0.68rem 0.9rem;
    color: var(--permission-text);
    cursor: pointer;
    transition: background-color 0.18s ease, color 0.18s ease;
}

.directory-permission-action:last-child {
    border-bottom: 0;
}

.directory-permission-action:hover,
.directory-permission-action--active {
    color: var(--permission-accent-dark);
    background: #f4fbf8;
}

.directory-permission-action__copy {
    display: inline-flex;
    min-width: 0;
    align-items: center;
    gap: 0.55rem;
    font-size: 0.84rem;
    font-weight: 700;
}

.directory-permission-action__icon {
    display: inline-flex;
    width: 1.55rem;
    height: 1.55rem;
    flex: 0 0 1.55rem;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--permission-accent);
    background: var(--permission-accent-soft);
    font-size: 0.72rem;
}

.directory-permission-action__input {
    width: 1rem;
    height: 1rem;
    flex: 0 0 1rem;
    accent-color: var(--permission-accent);
    cursor: pointer;
}

:global(#PermissionModal .modal-dialog) {
    max-width: min(66rem, calc(100vw - 2rem));
}

:global(#PermissionModal .modal-content) {
    border: 0;
    border-radius: 6px;
    box-shadow: 0 1.3rem 3rem rgba(18, 28, 24, 0.24);
    overflow: hidden;
}

:global(#PermissionModal .modal-header) {
    min-height: 4rem;
    border-bottom: 1px solid #d7e0da;
    padding: 1rem 1.15rem;
    background: #ffffff;
}

:global(#PermissionModal .modal-title) {
    color: #252821;
    font-size: 1.25rem;
    font-weight: 700;
}

:global(#PermissionModal .btn-close) {
    box-shadow: none;
}

:global(#PermissionModal .btn-close:hover) {
    opacity: 0.7;
}

:global(#PermissionModal .modal-body) {
    padding: 1rem;
    background: #f7f9f8;
}

:global(#PermissionModal .modal-footer) {
    border-top: 1px solid #d7e0da;
    padding: 1rem 1.15rem;
    background: #ffffff;
}

:global(#PermissionModal .modal-footer .btn) {
    min-width: 9rem;
    min-height: 2.65rem;
    border-radius: 4px;
    font-weight: 800;
}

:global(#PermissionModal .modal-footer .btn-outline-danger) {
    border-color: #dddddd;
    color: #1f241f;
    background: #dddddd;
}

:global(#PermissionModal .modal-footer .btn-outline-danger:hover) {
    border-color: #d2d2d2;
    color: #1f241f;
    background: #d2d2d2;
}

:global(#PermissionModal .modal-footer .btn-primary) {
    border-color: #ff5b22;
    background: #ff5b22;
}

:global(#PermissionModal .modal-footer .btn-primary:hover) {
    border-color: #e84f1b;
    background: #e84f1b;
}
</style>
